module.exports = __webpack_public_path__ + "static/media/lv.73c84460.webp";